import React from 'react';
import { Alert, Button, LinearProgress } from '@mui/material';
import { useOperations } from './OperationsProvider';

const OperationsStatus = () => {
  const {
    error, partialError, loading, updatedAt, refresh,
  } = useOperations();
  return (
    <>
      {loading && <LinearProgress aria-label="Refreshing operations" sx={{ mb: 2 }} />}
      {error && <Alert sx={{ mb: 2 }} severity="warning" action={<Button onClick={refresh} disabled={loading}>Retry</Button>}>{`${error}${updatedAt ? ' Showing previously received records.' : ''}`}</Alert>}
      {!error && partialError && <Alert sx={{ mb: 2 }} severity="info" action={<Button onClick={refresh} disabled={loading}>Retry</Button>}>{partialError}</Alert>}
    </>
  );
};
export default OperationsStatus;
